import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from "@/components/ui/button";
import { cn } from '@/lib/utils';

export default function PageHeader({
  title,
  subtitle,
  showBack = true,
  action,
  className = '',
  backButtonClassName = '',
  titleClassName = '',
  subtitleClassName = '',
}) {
  const navigate = useNavigate();
  const safeAreaStyle = {
    paddingTop: 'calc(env(safe-area-inset-top, 0px) + 28px)',
  };
  const MotionButton = motion(Button);

  return (
    <div className={cn('mbv-page-header flex items-start justify-between gap-3 mb-6', className)} style={safeAreaStyle}>
      <div className="mbv-page-header-title flex items-start gap-3 min-w-0">
        {showBack && (
          <MotionButton
            variant="ghost" 
            size="icon" 
            onClick={() => navigate(-1)}
            initial={{ opacity: 0, x: -10, scale: 0.92 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            whileHover={{ x: -3, scale: 1.04 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: 'spring', stiffness: 420, damping: 24 }}
            className={cn(
              'mbv-back-button group rounded-full shrink-0 h-12 w-12 border border-[#d8bd68] bg-[#d8bd68] text-[#1a1918]',
              'hover:bg-[#e5ce80] active:bg-[#c9aa4d] focus-visible:ring-2 focus-visible:ring-[#d8bd68]',
              backButtonClassName,
            )}
            aria-label="Voltar"
          >
            <ArrowLeft className="h-5 w-5 text-[#1a1918] transition-transform duration-200 group-hover:-translate-x-0.5" strokeWidth={2.4} />
          </MotionButton>
        )}
        <div className="min-w-0">
          <h1 className={cn('text-xl md:text-2xl font-bold text-inherit leading-tight break-words', titleClassName)}>{title}</h1>
          {subtitle && <p className={cn('text-sm text-current/70 mt-0.5 leading-snug', subtitleClassName)}>{subtitle}</p>}
        </div>
      </div>
      {action && <div className="mbv-page-header-action">{action}</div>}
    </div>
  );
}
